import React from "react";
import AliceCarousel from "react-alice-carousel";
import "react-alice-carousel/lib/alice-carousel.css";

// Files Import
import { content } from "../../../data";

const responsive = {
  0: { items: 2 },
  550: { items: 3 },
  800: { items: 3 },
  1000: { items: 4 },
  1200: { items: 5 },
};

const renderPrevButton = ({ isDisabled }) => {
  return (
    <button
      disabled={isDisabled}
      className={`rotate-180 flex absolute items-center justify-center left-[35%] sm:left-[43%] top-[100%] md:-top-[14%] md:left-[87%] lg:right-3 ${
        isDisabled ? "opacity-50" : "opacity-100"
      }`}
    >
      <img
        src="/assets/forward-arrow.svg"
        alt="Next Button"
        width={28}
        height={8}
      />
    </button>
  );
};

const renderNextButton = ({ isDisabled }) => {
  return (
    <button
      disabled={isDisabled}
      className={`flex absolute items-center justify-center right-[35%] sm:right-[43%] top-[100%] md:-top-[14%] md:right-[1%] ${
        isDisabled ? "opacity-50" : "opacity-100"
      }`}
    >
      <img
        src="/assets/forward-arrow.svg"
        alt="Next Button"
        width={28}
        height={8}
      />
    </button>
  );
};

const CuratedCollectionCarousel = () => (
  <div>
    <AliceCarousel
      mouseTracking
      responsive={responsive}
      renderPrevButton={renderPrevButton}
      renderNextButton={renderNextButton}
      controlsStrategy="alternate"
      disableDotsControls
      items={content.CuratedNFTs.map((item, index) => (
        <div key={index} className="flex flex-col gap-3 mx-1.5">
          <img src={item.imgUrl} alt="NFT's" loading="lazy" />
          <img src={item.imgUrl2} alt="NFT's" loading="lazy"/>
        </div>
      ))}
    />
  </div>
);
export default CuratedCollectionCarousel;
